import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';

interface EventFilterProps {
  selectedEventId: string;
  onEventChange: (eventId: string) => void;
  uniqueEventIds: string[];
}

export const EventFilter = ({ selectedEventId, onEventChange, uniqueEventIds }: EventFilterProps) => {
  return (
    <FormControl size="small" fullWidth>
      <InputLabel>이벤트 선택</InputLabel>
      <Select
        value={selectedEventId}
        label="이벤트 선택"
        onChange={(e) => onEventChange(e.target.value)}
      >
        <MenuItem value="all">전체</MenuItem>
        {uniqueEventIds.map(eventId => (
          <MenuItem key={eventId} value={eventId}>{eventId}</MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}; 